const RootNavWrapper = require('../../src/js/client/rootNavWrapper').default;

exports.rootNavWrapper = RootNavWrapper;
